import logo from 'assets/images/winq_logo.png';
import logoPayoff from 'assets/images/winq_payoff.png';
import defaultConfigs from './default';

const AWS = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:794f9c34-acdd-4507-a3a7-23d7c12f4148',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_Qs4OBl5FP',
  aws_user_pools_web_client_id: '7cg6fn9arnv9j514e4bln6sck3',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: '8',
    passwordPolicyCharacters: ['REQUIRES_NUMBERS'],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_appsync_graphqlEndpoint:
    'https://ik4vupv3qbae5gcniigrxn4zy4.appsync-api.eu-west-1.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cloud_logic_custom: [
    {
      name: 'userapi',
      endpoint: 'https://22uphuf934.execute-api.eu-west-1.amazonaws.com/winq',
      region: 'eu-west-1',
    },
  ],
  aws_user_files_s3_bucket: 'clinicardstorage113105-winq',
  aws_user_files_s3_bucket_region: 'eu-west-1',
  aws_cognito_login_mechanisms: ['EMAIL'],
  Auth: {
    cookieStorage: {
      domain:
        process.env.NODE_ENV === 'production'
          ? 'winq.clinicards.app'
          : 'localhost',
      path: '/',
      expires: 1,
      secure: process.env.NODE_ENV === 'production',
    },
  },
};

const defaultCarepathCards = [];

export default {
  ...defaultConfigs,
  APP_TITLE: 'WinQ',
  ENABLE_ARTICLES: true,
  ENABLE_CAREPATH: true,
  ENABLE_MEDICAL_PROFILE: false,
  ENABLE_PERMISSIONS: true,
  ENABLE_MANAGEMENT: true,
  ENABLE_ORGANISATION_LEVEL: true,
  ENABLE_ORGANISATION_MULTIPLE: true,
  ENABLE_INSIGHTS: true,
  ENABLE_OPERATION_PROFILE: true,
  ENABLE_STICKY_CAREPATHITEM: true,
  ENABLE_ACTIVATIONPERIOD_CAREPATHITEM: true,
  ENABLE_RANDOMISATION: true,
  ENABLE_ANONYMITY: true,
  ENABLE_INSTANCE_SPECIC_NAMING: true,
  AWS,
  logo,
  logoPayoff,
  defaultCarepathCards,
};
